// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#pai {
    width: 94%;
}

/* ---------------------------------------------------
    TABELA
----------------------------------------------------- */

.tabela {
    overflow-y: scroll;
    margin: 0 -15% 0% 4%;
    height: 365px;
    text-align: center;
    width: 111%;

}

th {
    position: sticky;
    position: -webkit-sticky;
    top: 0;
    background: #007bff;
    color: white;
}

@media only screen and (max-width: 768px) {
    .tabela {
        margin: 0 -15% 0% 3%;
        width: 111%;
    }




}

/* ---------------------------------------------------
    CARD
----------------------------------------------------- */



.title-card {
    font-weight: bold;
    margin: 5% 0 5% 5%
}

.cardFornecedor {
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12), 0 3px 1px -2PX rgba(0, 0, 0, 0.20);
    margin: 0 0% 5% 2%;
    width: 110%;
}

@media only screen and (max-width: 768px) {
    .title-card {
        font-weight: bold;
        margin: 5% 0 5% 5%
    }

    .cardFornecedor {
        width: 111%;
        box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12), 0 3px 1px -2PX rgba(0, 0, 0, 0.20);
        margin: 0 0% 5% 3%;
    }
}

/* ---------------------------------------------------
    INPUTS
----------------------------------------------------- */

#data {
    background-color: transparent;
    border: none;
    border-bottom: 1px solid black;
    border-radius: 0;
    outline: none;
    height: 2rem;
    width: 100%;
    font-size: 1rem;
    margin: 0 2% 0 15%;
    padding: 0;
    box-shadow: none;
    box-sizing: content-box;
    transition: all 0.3s;
}

#data1 {
    background-color: transparent;
    border: none;
    border-bottom: 1px solid black;
    border-radius: 0;
    outline: none;
    height: 2rem;
    width: 100%;
    font-size: 1rem;
    margin: 0 2% 0 8%;
    padding: 0;
    box-shadow: none;
    box-sizing: content-box;
    transition: all 0.3s;
}

#dateInput {
    width: 30%;
}

#dateInput1 {
    width: 30%;
}

@media only screen and (max-width: 768px) {
    #dateInput {
        width: 100%;
        padding-right: 0%;
        margin-bottom: 4%;
    }

    #dateInput1 {
        width: 100%;
        padding-right: 0%;
        margin-bottom: 4%;
    }

    #data {
        border-style: hidden hidden solid hidden;
        width: 90%;
        margin-left: 10%;
        padding: 0%;
        position: relative;
    }

    #data1 {
        border-style: hidden hidden solid hidden;
        margin-left: 10%;
        width: 90%;
        padding: 0%;
        position: relative;
    }

    #data1 .react-datepicker-ignore-onclickoutside .react-datepicker-popper {
        left: -94px;
        position: absolute;
    }
}


/* ---------------------------------------------------
    INPUTS POR CODIGO GERAL/POR ITEM GERAL
----------------------------------------------------- */


.revistaLabel {
    margin: 0 0 0 7%;
}

#revista {
    border-style: hidden hidden solid hidden;
    border-radius: 0%;
    width: 47%;
    margin: 0 0 0 7%;
    border-bottom: 1px solid black;
    font-size: 2vh;
}

@media only screen and (max-width: 768px) {
    .revistaLabel {
        margin: 0 0 0 6%;
    }

    #revista {
        border-style: hidden hidden solid hidden;
        border-radius: 0%;
        width: 98%;
        margin: 0 0 0 6%;
    }
}

/* ---------------------------------------------------
    INPUTS POR ITEM TAMANHOS
----------------------------------------------------- */


.revistaLabel2 {
    margin: 0 2% 0 15%;
}

#revista2 {
    border-style: hidden hidden solid hidden;
    border-radius: 0%;
    width: 100%;
    margin: 0 0 0 15%;
    border-bottom: 1px solid black;
    font-size: 2vh;
}

.referenciaLabel2 {
    margin: 2% 2% 0 10%;
}

#referencia2 {
    border-style: hidden hidden solid hidden;
    border-radius: 0%;
    width: 100%;
    margin: 0 0 0 8%;
    border-bottom: 1px solid black;
}

@media only screen and (max-width: 768px) {
    .revistaLabel2 {
        margin: 0 2% 0 6%;
    }

    #revista2 {
        border-style: hidden hidden solid hidden;
        border-radius: 0%;
        width: 98%;
        margin: 0 0 0 6%;
    }

    .referenciaLabel2 {
        margin: 0 0% 0 6%;
    }

    #referencia2 {
        border-style: hidden hidden solid hidden;
        border-radius: 0%;
        width: 98%;
        margin: 0 0 0 6%;
    }
}

/* ---------------------------------------------------
    INPUTS POR ITEM LOJA
----------------------------------------------------- */


.revistaLabel3 {
    margin: 0 2% 0 15%;
}

#revista3 {
    border-style: hidden hidden solid hidden;
    border-radius: 0%;
    width: 100%;
    margin: 0 0 0 15%;
    border-bottom: 1px solid black;
    font-size: 2vh;
}

.referenciaLabel3 {
    margin: 2% 2% 0 10%;
}

#referencia3 {
    border-style: hidden hidden solid hidden;
    border-radius: 0%;
    width: 100%;
    margin: 0 0 0 8%;
    border-bottom: 1px solid black;
}


@media only screen and (max-width: 768px) {
    .revistaLabel3 {
        margin: 0 2% 0 6%;
    }

    #revista3 {
        border-style: hidden hidden solid hidden;
        border-radius: 0%;
        width: 98%;
        margin: 0 0 0 6%;
    }

    .referenciaLabel3 {
        margin: 0 0% 0 6%;
    }

    #referencia3 {
        border-style: hidden hidden solid hidden;
        border-radius: 0%;
        width: 98%;
        margin: 0 0 0 6%;
    }
}

/* ---------------------------------------------------
    INPUTS ACUMULADO POR LOJA
----------------------------------------------------- */


.revistaLabel4 {
    margin: 0 2% 0 15%;
}

#revista4 {
    border-style: hidden hidden solid hidden;
    border-radius: 0%;
    width: 100%;
    margin: 0 0 0 15%;
    border-bottom: 1px solid black;
    font-size: 2vh;
}

@media only screen and (max-width: 768px) {
    .revistaLabel4 {
        margin: 0 2% 0 6%;
    }

    #revista4 {
        border-style: hidden hidden solid hidden;
        border-radius: 0%;
        width: 98%;
        margin: 0 0 0 6%;
    }
}

/* ---------------------------------------------------
    INPUTS POR CODIGO E LOJA
----------------------------------------------------- */


.revistaLabel5 {
    margin: 0 2% 0 15%;
}

#revista5 {
    border-style: hidden hidden solid hidden;
    border-radius: 0%;
    width: 100%;
    margin: 0 0 0 15%;
    border-bottom: 1px solid black;
    font-size: 2vh;
}

.revistaLabel6 {
    margin: 0 2% 0 10%;
}

#revista6 {
    border-style: hidden hidden solid hidden;
    border-radius: 0%;
    width: 98%;
    margin: 0 0 0 10%;
    border-bottom: 1px solid black;
    font-size: 2vh;
}

@media only screen and (max-width: 768px) {
    .revistaLabel5 {
        margin: 0 2% 0 6%;
    }

    #revista5 {
        border-style: hidden hidden solid hidden;
        border-radius: 0%;
        width: 98%;
        margin: 0 0 0 6%;
    }

    .revistaLabel6 {
        margin: 0 2% 0 6%;
    }

    #revista6 {
        border-style: hidden hidden solid hidden;
        border-radius: 0%;
        width: 98%;
        margin: 0 0 0 6%;
    }
}

/* ---------------------------------------------------
    INPUTS POR CODIGO LOJA
----------------------------------------------------- */


.revistaLabel7 {
    margin: 0 2% 0 15%;
}

#revista7 {
    border-style: hidden hidden solid hidden;
    border-radius: 0%;
    width: 100%;
    margin: 0 0 0 15%;
    border-bottom: 1px solid black;
    font-size: 2vh;
}

.revistaLabel8 {
    margin: 0 2% 0 15%;
}

#revista8 {
    border-style: hidden hidden solid hidden;
    border-radius: 0%;
    width: 100%;
    margin: 0 0 0 10%;
    border-bottom: 1px solid black;
    font-size: 2vh;
}

.revistaLabel9 {
    margin: 0 2% 0 15%;
}

#revista9 {
    border-style: hidden hidden solid hidden;
    border-radius: 0%;
    width: 100%;
    margin: 0 0 0 15%;
    border-bottom: 1px solid black;
}

@media only screen and (max-width: 768px) {
    .revistaLabel7 {
        margin: 0 2% 0 6%;
    }

    #revista7 {
        border-style: hidden hidden solid hidden;
        border-radius: 0%;
        width: 98%;
        margin: 0 0 0 6%;
    }

    .revistaLabel8 {
        margin: 0 2% 0 6%;
    }

    #revista8 {
        border-style: hidden hidden solid hidden;
        border-radius: 0%;
        width: 98%;
        margin: 0 0 0 6%;
    }

    .revistaLabel9 {
        margin: 0 2% 0 6%;
    }

    #revista9 {
        border-style: hidden hidden solid hidden;
        border-radius: 0%;
        width: 98%;
        margin: 0 0 0 6%;
    }
}

/* ---------------------------------------------------
    INPUTS POR CODIGO LOJA
----------------------------------------------------- */


.revistaLabel10 {
    margin: 0 2% 0 15%;
}

#revista10 {
    border-style: hidden hidden solid hidden;
    border-radius: 0%;
    width: 100%;
    margin: 0 0 0 15%;
    border-bottom: 1px solid black;
    font-size: 2vh;
}

@media only screen and (max-width: 768px) {
    .revistaLabel10 {
        margin: 0 2% 0 6%;
    }

    #revista10 {
        border-style: hidden hidden solid hidden;
        border-radius: 0%;
        width: 98%;
        margin: 0 0 0 6%;
    }

}

/* ---------------------------------------------------
    BUTTON LIMPAR
----------------------------------------------------- */

div .buttonLimpar {
    margin: 0% 0% 0% 15%;
    width: 100%;
    position: relative;
    padding-top: 1%;
    background: white;
    border-radius: 0%;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12), 0 3px 1px -2px rgba(0, 0, 0, 0.2);
    border: none;
    color: #007bff;
}


div .buttonLimpar:hover {
    background: #007bff;
    color: white;
}

div .buttonLimpar:focus {
    background: #007bff;
    color: white;
}


@media only screen and (max-width: 768px) {
    div .buttonLimpar {
        padding: 0% 0% 0% 0%;
        width: 100%;
        position: relative;
        margin: 0% 0% 0% 5%;
        padding-top: 1%;
        background: white;
        border-radius: 0%;
        box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12), 0 3px 1px -2px rgba(0, 0, 0, 0.2);
        border: none;
        color: #007bff;
    }
}

/* ---------------------------------------------------
    BUTTON FILTRAR
----------------------------------------------------- */

div .buttonFiltrar {
    padding: 0% 0% 2, 5% 0%;
    position: relative;
    margin: 0% 0% 0% 15%;
    width: 100%;
    padding-top: 1%;
    background: #007bff;
    border-radius: 0%;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12), 0 3px 1px -2px rgba(0, 0, 0, 0.2);
    border: none;
}

div .buttonFiltrar:hover {
    background: white;
    color: #007bff;
}


div .buttonFiltrar:focus {
    background: white;
    color: #007bff;
}



@media only screen and (max-width: 768px) {
    div .buttonFiltrar {
        padding: 2% 0;
        width: 102%;
        position: relative;
        margin: 0% 0% 0% 5%;
        padding-top: 1%;
        background: #007bff;
        border-radius: 0%;
        box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12), 0 3px 1px -2px rgba(0, 0, 0, 0.2);
        border: none;
    }
}

/* ---------------------------------------------------
    BUTTON IMPRIMIR
----------------------------------------------------- */

.buttonImprimir {
    padding: 0% 0% 0% 0%;
    width: 100%;
    margin: 0% 0% 0% 15%;
    position: relative;
}



div .buttonImprimir {
    padding-top: 1%;
    background: #007bff;
    border-radius: 0%;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12), 0 3px 1px -2px rgba(0, 0, 0, 0.2);
    border: none;
    margin: 0% 0% 0% 8%;
}

div .buttonImprimir:hover {
    background: white;
    color: #007bff;
}


div .buttonImprimir:focus {
    background: white;
    color: #007bff;
}



@media only screen and (max-width: 768px) {
    div .buttonImprimir {
        background: #007bff;
        border-radius: 0%;
        box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12), 0 3px 1px -2px rgba(0, 0, 0, 0.2);
        border: none;
        padding: 2% 0;
        margin: 0% 0% 0% 5%;
    }

    .buttonImprimir {
        padding: 0% 0% 0% 0%;
        width: 102%;
        position: relative;
    }
}

/* ---------------------------------------------------
    BUTTON BAIXAR
----------------------------------------------------- */

#test-table-xls-button {
    padding: 4% 0%;
    width: 100%;
    position: relative;
    margin: 0% 2% 0% 15%;
}

div #test-table-xls-button {
    padding-top: 1%;
    background: #007bff;
    color: white;
    border-radius: 0%;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12), 0 3px 1px -2px rgba(0, 0, 0, 0.2);
    border: none;
}

div #test-table-xls-button:hover {
    background: white;
    color: #007bff;
}


div #test-table-xls-button:focus {
    background: white;
    color: #007bff;
}



@media only screen and (max-width: 768px) {
    div #test-table-xls-button {
        padding: 2% 0;
        background: #007bff;
        border-radius: 0%;
        box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12), 0 3px 1px -2px rgba(0, 0, 0, 0.2);
        border: none;
        color: white
    }

    #test-table-xls-button {
        padding: 0% 0% 0% 0%;
        margin: 0% 0% 0% 5%;
        width: 102%;
        position: relative;
    }

}





.hide {
    display: none;
}

#formselect {
    padding: 4px 4px 4px 4px;
    width: 100%;
}

.enter {
    margin: 5% 0% 0% 0%;
}

.centrocentro {
    text-align-last: center;

}


/* ---------------------------------------------------
    Select Tabela
----------------------------------------------------- */


.labelSelect {
    font-weight: bold;
    font-size: 22px;
}

#select {
    border-style: hidden hidden solid hidden;
    border-radius: 0%;
    width: 25%;
}

@media only screen and (max-width: 768px) {
    #select {
        border-style: hidden hidden solid hidden;
        border-radius: 0%;
        width: 80%;
    }
}

.silas {
    background: #007bff;
    color: white;
}


.alinhamento {
    text-align: center;
}












/* ================================================== */


/* Estilo para a div principal */
.metaslojas  {
    margin: 10px;
    padding: 10px;
    border-radius: 5px;
    box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1);
}

/* Estilo para a label com o nome do vendedor */
.metaslojas label {
    display: block;
    margin: 10px 0 5px;
    font-size: 18px;
    font-weight: bold;
    color: #fff;
    background-color: #1e88e5;
    /* padding: 5px 10px; */
    border-radius: 3px;
    text-align: center;
}

/* Estilo para a barra de progresso */
.metaslojas progress {
    display: block;
    margin-bottom: 30px;
}

/* Estilo para a label de cada item da barra de progresso */
.metaslojas progress label {
    font-size: 14px;
    font-weight: bold;
}

/* Estilo para a barra de progresso de vendas */
.metaslojas progress [value="100"]::-webkit-progress-value {
    background-color: #28a745;
}

/* Estilo para a barra de progresso de falta */
.metaslojas progress [value="100"]::-webkit-progress-value {
    background-color: #dc3545;
}




/* ---------------------------------------------------
    modal
----------------------------------------------------- */

.modal-overlay {
    background-color: rgba(0, 0, 0, 0.5);
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .modal-content {
    background-color: rgb(153, 144, 144);
    padding: 20px;
    border-radius: 5px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    width: 400px;
  }
  
  .modal-close {
    position: absolute;
    top: 10px;
    right: 10px;
    cursor: pointer;
  }
  
  .modal-close-button {
    background-color: #f10909;
    color: #f7f3f3;
    border: none;
    padding: 8px 16px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    float:left;
    font-size: large;
    margin-left:2%;
    margin-top: 1%;
  }
  
  .modal-close-button:hover {
    background-color: #460303;
  }
  

    /* Estilos para o loading */

    .loading-container {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.7);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 9999;
      }
      
      .loading {
        border: 4px solid #f3f3f3;
        border-top: 4px solid #3498db;
        border-radius: 50%;
        width: 40px;
        height: 40px;
        animation: spin 2s linear infinite;
      }
    
      @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }`, "",{"version":3,"sources":["webpack://./src/components/metavendendorageralNEW/metavendedorageral.css"],"names":[],"mappings":"AAAA;IACI,UAAU;AACd;;AAEA;;uDAEuD;;AAEvD;IACI,kBAAkB;IAClB,oBAAoB;IACpB,aAAa;IACb,kBAAkB;IAClB,WAAW;;AAEf;;AAEA;IACI,gBAAgB;IAChB,wBAAwB;IACxB,MAAM;IACN,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI;QACI,oBAAoB;QACpB,WAAW;IACf;;;;;AAKJ;;AAEA;;uDAEuD;;;;AAIvD;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI,gHAAgH;IAChH,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI,WAAW;QACX,gHAAgH;QAChH,kBAAkB;IACtB;AACJ;;AAEA;;uDAEuD;;AAEvD;IACI,6BAA6B;IAC7B,YAAY;IACZ,8BAA8B;IAC9B,gBAAgB;IAChB,aAAa;IACb,YAAY;IACZ,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,UAAU;IACV,gBAAgB;IAChB,uBAAuB;IACvB,oBAAoB;AACxB;;AAEA;IACI,6BAA6B;IAC7B,YAAY;IACZ,8BAA8B;IAC9B,gBAAgB;IAChB,aAAa;IACb,YAAY;IACZ,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,UAAU;IACV,gBAAgB;IAChB,uBAAuB;IACvB,oBAAoB;AACxB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI;QACI,WAAW;QACX,iBAAiB;QACjB,iBAAiB;IACrB;;IAEA;QACI,WAAW;QACX,iBAAiB;QACjB,iBAAiB;IACrB;;IAEA;QACI,wCAAwC;QACxC,UAAU;QACV,gBAAgB;QAChB,WAAW;QACX,kBAAkB;IACtB;;IAEA;QACI,wCAAwC;QACxC,gBAAgB;QAChB,UAAU;QACV,WAAW;QACX,kBAAkB;IACtB;;IAEA;QACI,WAAW;QACX,kBAAkB;IACtB;AACJ;;;AAGA;;uDAEuD;;;AAGvD;IACI,gBAAgB;AACpB;;AAEA;IACI,wCAAwC;IACxC,iBAAiB;IACjB,UAAU;IACV,gBAAgB;IAChB,8BAA8B;IAC9B,cAAc;AAClB;;AAEA;IACI;QACI,gBAAgB;IACpB;;IAEA;QACI,wCAAwC;QACxC,iBAAiB;QACjB,UAAU;QACV,gBAAgB;IACpB;AACJ;;AAEA;;uDAEuD;;;AAGvD;IACI,kBAAkB;AACtB;;AAEA;IACI,wCAAwC;IACxC,iBAAiB;IACjB,WAAW;IACX,iBAAiB;IACjB,8BAA8B;IAC9B,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,wCAAwC;IACxC,iBAAiB;IACjB,WAAW;IACX,gBAAgB;IAChB,8BAA8B;AAClC;;AAEA;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,wCAAwC;QACxC,iBAAiB;QACjB,UAAU;QACV,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,wCAAwC;QACxC,iBAAiB;QACjB,UAAU;QACV,gBAAgB;IACpB;AACJ;;AAEA;;uDAEuD;;;AAGvD;IACI,kBAAkB;AACtB;;AAEA;IACI,wCAAwC;IACxC,iBAAiB;IACjB,WAAW;IACX,iBAAiB;IACjB,8BAA8B;IAC9B,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,wCAAwC;IACxC,iBAAiB;IACjB,WAAW;IACX,gBAAgB;IAChB,8BAA8B;AAClC;;;AAGA;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,wCAAwC;QACxC,iBAAiB;QACjB,UAAU;QACV,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,wCAAwC;QACxC,iBAAiB;QACjB,UAAU;QACV,gBAAgB;IACpB;AACJ;;AAEA;;uDAEuD;;;AAGvD;IACI,kBAAkB;AACtB;;AAEA;IACI,wCAAwC;IACxC,iBAAiB;IACjB,WAAW;IACX,iBAAiB;IACjB,8BAA8B;IAC9B,cAAc;AAClB;;AAEA;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,wCAAwC;QACxC,iBAAiB;QACjB,UAAU;QACV,gBAAgB;IACpB;AACJ;;AAEA;;uDAEuD;;;AAGvD;IACI,kBAAkB;AACtB;;AAEA;IACI,wCAAwC;IACxC,iBAAiB;IACjB,WAAW;IACX,iBAAiB;IACjB,8BAA8B;IAC9B,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,wCAAwC;IACxC,iBAAiB;IACjB,UAAU;IACV,iBAAiB;IACjB,8BAA8B;IAC9B,cAAc;AAClB;;AAEA;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,wCAAwC;QACxC,iBAAiB;QACjB,UAAU;QACV,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,wCAAwC;QACxC,iBAAiB;QACjB,UAAU;QACV,gBAAgB;IACpB;AACJ;;AAEA;;uDAEuD;;;AAGvD;IACI,kBAAkB;AACtB;;AAEA;IACI,wCAAwC;IACxC,iBAAiB;IACjB,WAAW;IACX,iBAAiB;IACjB,8BAA8B;IAC9B,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,wCAAwC;IACxC,iBAAiB;IACjB,WAAW;IACX,iBAAiB;IACjB,8BAA8B;IAC9B,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,wCAAwC;IACxC,iBAAiB;IACjB,WAAW;IACX,iBAAiB;IACjB,8BAA8B;AAClC;;AAEA;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,wCAAwC;QACxC,iBAAiB;QACjB,UAAU;QACV,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,wCAAwC;QACxC,iBAAiB;QACjB,UAAU;QACV,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,wCAAwC;QACxC,iBAAiB;QACjB,UAAU;QACV,gBAAgB;IACpB;AACJ;;AAEA;;uDAEuD;;;AAGvD;IACI,kBAAkB;AACtB;;AAEA;IACI,wCAAwC;IACxC,iBAAiB;IACjB,WAAW;IACX,iBAAiB;IACjB,8BAA8B;IAC9B,cAAc;AAClB;;AAEA;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,wCAAwC;QACxC,iBAAiB;QACjB,UAAU;QACV,gBAAgB;IACpB;;AAEJ;;AAEA;;uDAEuD;;AAEvD;IAEI,oBAAoB;IACpB,WAAW;IACX,kBAAkB;IAIlB,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,+GAA+G;IAC/G,YAAY;IACZ,cAAc;AARlB;;;AAYA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;;AAGA;IACI;QACI,oBAAoB;QACpB,WAAW;QACX,kBAAkB;QAClB,mBAAmB;QAInB,eAAe;QACf,iBAAiB;QACjB,iBAAiB;QACjB,+GAA+G;QAC/G,YAAY;QACZ,cAAc;IARlB;AAUJ;;AAEA;;uDAEuD;;AAEvD;IACI,uBAAuB;IACvB,kBAAkB;IAClB,oBAAoB;IACpB,WAAW;IAKX,eAAe;IACf,mBAAmB;IACnB,iBAAiB;IACjB,+GAA+G;IAC/G,YAAY;AARhB;;AAWA;IACI,iBAAiB;IACjB,cAAc;AAClB;;;AAGA;IACI,iBAAiB;IACjB,cAAc;AAClB;;;;AAIA;IACI;QACI,aAAa;QACb,WAAW;QACX,kBAAkB;QAClB,mBAAmB;QAInB,eAAe;QACf,mBAAmB;QACnB,iBAAiB;QACjB,+GAA+G;QAC/G,YAAY;IAPhB;AASJ;;AAEA;;uDAEuD;;AAEvD;IACI,oBAAoB;IACpB,WAAW;IACX,oBAAoB;IACpB,kBAAkB;AACtB;;;;AAIA;IACI,eAAe;IACf,mBAAmB;IACnB,iBAAiB;IACjB,+GAA+G;IAC/G,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;;AAGA;IACI,iBAAiB;IACjB,cAAc;AAClB;;;;AAIA;IACI;QACI,mBAAmB;QACnB,iBAAiB;QACjB,+GAA+G;QAC/G,YAAY;QACZ,aAAa;QACb,mBAAmB;IACvB;;IAEA;QACI,oBAAoB;QACpB,WAAW;QACX,kBAAkB;IACtB;AACJ;;AAEA;;uDAEuD;;AAEvD;IACI,cAAc;IACd,WAAW;IACX,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,+GAA+G;IAC/G,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;;AAGA;IACI,iBAAiB;IACjB,cAAc;AAClB;;;;AAIA;IACI;QACI,aAAa;QACb,mBAAmB;QACnB,iBAAiB;QACjB,+GAA+G;QAC/G,YAAY;QACZ;IACJ;;IAEA;QACI,oBAAoB;QACpB,mBAAmB;QACnB,WAAW;QACX,kBAAkB;IACtB;;AAEJ;;;;;;AAMA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;IACxB,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;;AAE3B;;;AAGA;;uDAEuD;;;AAGvD;IACI,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,wCAAwC;IACxC,iBAAiB;IACjB,UAAU;AACd;;AAEA;IACI;QACI,wCAAwC;QACxC,iBAAiB;QACjB,UAAU;IACd;AACJ;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;;AAGA;IACI,kBAAkB;AACtB;;;;;;;;;;;;;AAaA,uDAAuD;;;AAGvD,gCAAgC;AAChC;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,0CAA0C;AAC9C;;AAEA,+CAA+C;AAC/C;IACI,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,yBAAyB;IACzB,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA,qCAAqC;AACrC;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA,2DAA2D;AAC3D;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA,+CAA+C;AAC/C;IACI,yBAAyB;AAC7B;;AAEA,8CAA8C;AAC9C;IACI,yBAAyB;AAC7B;;;;;AAKA;;uDAEuD;;AAEvD;IACI,oCAAoC;IACpC,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,oCAAoC;IACpC,aAAa;IACb,kBAAkB;IAClB,wCAAwC;IACxC,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,yBAAyB;IACzB,cAAc;IACd,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,UAAU;IACV,gBAAgB;IAChB,cAAc;IACd,cAAc;EAChB;;EAEA;IACE,yBAAyB;EAC3B;;;IAGE,2BAA2B;;IAE3B;QACI,eAAe;QACf,MAAM;QACN,OAAO;QACP,WAAW;QACX,YAAY;QACZ,oCAAoC;QACpC,aAAa;QACb,uBAAuB;QACvB,mBAAmB;QACnB,aAAa;MACf;;MAEA;QACE,yBAAyB;QACzB,6BAA6B;QAC7B,kBAAkB;QAClB,WAAW;QACX,YAAY;QACZ,kCAAkC;MACpC;;MAEA;QACE,KAAK,uBAAuB,EAAE;QAC9B,OAAO,yBAAyB,EAAE;MACpC","sourcesContent":["#pai {\n    width: 94%;\n}\n\n/* ---------------------------------------------------\n    TABELA\n----------------------------------------------------- */\n\n.tabela {\n    overflow-y: scroll;\n    margin: 0 -15% 0% 4%;\n    height: 365px;\n    text-align: center;\n    width: 111%;\n\n}\n\nth {\n    position: sticky;\n    position: -webkit-sticky;\n    top: 0;\n    background: #007bff;\n    color: white;\n}\n\n@media only screen and (max-width: 768px) {\n    .tabela {\n        margin: 0 -15% 0% 3%;\n        width: 111%;\n    }\n\n\n\n\n}\n\n/* ---------------------------------------------------\n    CARD\n----------------------------------------------------- */\n\n\n\n.title-card {\n    font-weight: bold;\n    margin: 5% 0 5% 5%\n}\n\n.cardFornecedor {\n    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12), 0 3px 1px -2PX rgba(0, 0, 0, 0.20);\n    margin: 0 0% 5% 2%;\n    width: 110%;\n}\n\n@media only screen and (max-width: 768px) {\n    .title-card {\n        font-weight: bold;\n        margin: 5% 0 5% 5%\n    }\n\n    .cardFornecedor {\n        width: 111%;\n        box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12), 0 3px 1px -2PX rgba(0, 0, 0, 0.20);\n        margin: 0 0% 5% 3%;\n    }\n}\n\n/* ---------------------------------------------------\n    INPUTS\n----------------------------------------------------- */\n\n#data {\n    background-color: transparent;\n    border: none;\n    border-bottom: 1px solid black;\n    border-radius: 0;\n    outline: none;\n    height: 2rem;\n    width: 100%;\n    font-size: 1rem;\n    margin: 0 2% 0 15%;\n    padding: 0;\n    box-shadow: none;\n    box-sizing: content-box;\n    transition: all 0.3s;\n}\n\n#data1 {\n    background-color: transparent;\n    border: none;\n    border-bottom: 1px solid black;\n    border-radius: 0;\n    outline: none;\n    height: 2rem;\n    width: 100%;\n    font-size: 1rem;\n    margin: 0 2% 0 8%;\n    padding: 0;\n    box-shadow: none;\n    box-sizing: content-box;\n    transition: all 0.3s;\n}\n\n#dateInput {\n    width: 30%;\n}\n\n#dateInput1 {\n    width: 30%;\n}\n\n@media only screen and (max-width: 768px) {\n    #dateInput {\n        width: 100%;\n        padding-right: 0%;\n        margin-bottom: 4%;\n    }\n\n    #dateInput1 {\n        width: 100%;\n        padding-right: 0%;\n        margin-bottom: 4%;\n    }\n\n    #data {\n        border-style: hidden hidden solid hidden;\n        width: 90%;\n        margin-left: 10%;\n        padding: 0%;\n        position: relative;\n    }\n\n    #data1 {\n        border-style: hidden hidden solid hidden;\n        margin-left: 10%;\n        width: 90%;\n        padding: 0%;\n        position: relative;\n    }\n\n    #data1 .react-datepicker-ignore-onclickoutside .react-datepicker-popper {\n        left: -94px;\n        position: absolute;\n    }\n}\n\n\n/* ---------------------------------------------------\n    INPUTS POR CODIGO GERAL/POR ITEM GERAL\n----------------------------------------------------- */\n\n\n.revistaLabel {\n    margin: 0 0 0 7%;\n}\n\n#revista {\n    border-style: hidden hidden solid hidden;\n    border-radius: 0%;\n    width: 47%;\n    margin: 0 0 0 7%;\n    border-bottom: 1px solid black;\n    font-size: 2vh;\n}\n\n@media only screen and (max-width: 768px) {\n    .revistaLabel {\n        margin: 0 0 0 6%;\n    }\n\n    #revista {\n        border-style: hidden hidden solid hidden;\n        border-radius: 0%;\n        width: 98%;\n        margin: 0 0 0 6%;\n    }\n}\n\n/* ---------------------------------------------------\n    INPUTS POR ITEM TAMANHOS\n----------------------------------------------------- */\n\n\n.revistaLabel2 {\n    margin: 0 2% 0 15%;\n}\n\n#revista2 {\n    border-style: hidden hidden solid hidden;\n    border-radius: 0%;\n    width: 100%;\n    margin: 0 0 0 15%;\n    border-bottom: 1px solid black;\n    font-size: 2vh;\n}\n\n.referenciaLabel2 {\n    margin: 2% 2% 0 10%;\n}\n\n#referencia2 {\n    border-style: hidden hidden solid hidden;\n    border-radius: 0%;\n    width: 100%;\n    margin: 0 0 0 8%;\n    border-bottom: 1px solid black;\n}\n\n@media only screen and (max-width: 768px) {\n    .revistaLabel2 {\n        margin: 0 2% 0 6%;\n    }\n\n    #revista2 {\n        border-style: hidden hidden solid hidden;\n        border-radius: 0%;\n        width: 98%;\n        margin: 0 0 0 6%;\n    }\n\n    .referenciaLabel2 {\n        margin: 0 0% 0 6%;\n    }\n\n    #referencia2 {\n        border-style: hidden hidden solid hidden;\n        border-radius: 0%;\n        width: 98%;\n        margin: 0 0 0 6%;\n    }\n}\n\n/* ---------------------------------------------------\n    INPUTS POR ITEM LOJA\n----------------------------------------------------- */\n\n\n.revistaLabel3 {\n    margin: 0 2% 0 15%;\n}\n\n#revista3 {\n    border-style: hidden hidden solid hidden;\n    border-radius: 0%;\n    width: 100%;\n    margin: 0 0 0 15%;\n    border-bottom: 1px solid black;\n    font-size: 2vh;\n}\n\n.referenciaLabel3 {\n    margin: 2% 2% 0 10%;\n}\n\n#referencia3 {\n    border-style: hidden hidden solid hidden;\n    border-radius: 0%;\n    width: 100%;\n    margin: 0 0 0 8%;\n    border-bottom: 1px solid black;\n}\n\n\n@media only screen and (max-width: 768px) {\n    .revistaLabel3 {\n        margin: 0 2% 0 6%;\n    }\n\n    #revista3 {\n        border-style: hidden hidden solid hidden;\n        border-radius: 0%;\n        width: 98%;\n        margin: 0 0 0 6%;\n    }\n\n    .referenciaLabel3 {\n        margin: 0 0% 0 6%;\n    }\n\n    #referencia3 {\n        border-style: hidden hidden solid hidden;\n        border-radius: 0%;\n        width: 98%;\n        margin: 0 0 0 6%;\n    }\n}\n\n/* ---------------------------------------------------\n    INPUTS ACUMULADO POR LOJA\n----------------------------------------------------- */\n\n\n.revistaLabel4 {\n    margin: 0 2% 0 15%;\n}\n\n#revista4 {\n    border-style: hidden hidden solid hidden;\n    border-radius: 0%;\n    width: 100%;\n    margin: 0 0 0 15%;\n    border-bottom: 1px solid black;\n    font-size: 2vh;\n}\n\n@media only screen and (max-width: 768px) {\n    .revistaLabel4 {\n        margin: 0 2% 0 6%;\n    }\n\n    #revista4 {\n        border-style: hidden hidden solid hidden;\n        border-radius: 0%;\n        width: 98%;\n        margin: 0 0 0 6%;\n    }\n}\n\n/* ---------------------------------------------------\n    INPUTS POR CODIGO E LOJA\n----------------------------------------------------- */\n\n\n.revistaLabel5 {\n    margin: 0 2% 0 15%;\n}\n\n#revista5 {\n    border-style: hidden hidden solid hidden;\n    border-radius: 0%;\n    width: 100%;\n    margin: 0 0 0 15%;\n    border-bottom: 1px solid black;\n    font-size: 2vh;\n}\n\n.revistaLabel6 {\n    margin: 0 2% 0 10%;\n}\n\n#revista6 {\n    border-style: hidden hidden solid hidden;\n    border-radius: 0%;\n    width: 98%;\n    margin: 0 0 0 10%;\n    border-bottom: 1px solid black;\n    font-size: 2vh;\n}\n\n@media only screen and (max-width: 768px) {\n    .revistaLabel5 {\n        margin: 0 2% 0 6%;\n    }\n\n    #revista5 {\n        border-style: hidden hidden solid hidden;\n        border-radius: 0%;\n        width: 98%;\n        margin: 0 0 0 6%;\n    }\n\n    .revistaLabel6 {\n        margin: 0 2% 0 6%;\n    }\n\n    #revista6 {\n        border-style: hidden hidden solid hidden;\n        border-radius: 0%;\n        width: 98%;\n        margin: 0 0 0 6%;\n    }\n}\n\n/* ---------------------------------------------------\n    INPUTS POR CODIGO LOJA\n----------------------------------------------------- */\n\n\n.revistaLabel7 {\n    margin: 0 2% 0 15%;\n}\n\n#revista7 {\n    border-style: hidden hidden solid hidden;\n    border-radius: 0%;\n    width: 100%;\n    margin: 0 0 0 15%;\n    border-bottom: 1px solid black;\n    font-size: 2vh;\n}\n\n.revistaLabel8 {\n    margin: 0 2% 0 15%;\n}\n\n#revista8 {\n    border-style: hidden hidden solid hidden;\n    border-radius: 0%;\n    width: 100%;\n    margin: 0 0 0 10%;\n    border-bottom: 1px solid black;\n    font-size: 2vh;\n}\n\n.revistaLabel9 {\n    margin: 0 2% 0 15%;\n}\n\n#revista9 {\n    border-style: hidden hidden solid hidden;\n    border-radius: 0%;\n    width: 100%;\n    margin: 0 0 0 15%;\n    border-bottom: 1px solid black;\n}\n\n@media only screen and (max-width: 768px) {\n    .revistaLabel7 {\n        margin: 0 2% 0 6%;\n    }\n\n    #revista7 {\n        border-style: hidden hidden solid hidden;\n        border-radius: 0%;\n        width: 98%;\n        margin: 0 0 0 6%;\n    }\n\n    .revistaLabel8 {\n        margin: 0 2% 0 6%;\n    }\n\n    #revista8 {\n        border-style: hidden hidden solid hidden;\n        border-radius: 0%;\n        width: 98%;\n        margin: 0 0 0 6%;\n    }\n\n    .revistaLabel9 {\n        margin: 0 2% 0 6%;\n    }\n\n    #revista9 {\n        border-style: hidden hidden solid hidden;\n        border-radius: 0%;\n        width: 98%;\n        margin: 0 0 0 6%;\n    }\n}\n\n/* ---------------------------------------------------\n    INPUTS POR CODIGO LOJA\n----------------------------------------------------- */\n\n\n.revistaLabel10 {\n    margin: 0 2% 0 15%;\n}\n\n#revista10 {\n    border-style: hidden hidden solid hidden;\n    border-radius: 0%;\n    width: 100%;\n    margin: 0 0 0 15%;\n    border-bottom: 1px solid black;\n    font-size: 2vh;\n}\n\n@media only screen and (max-width: 768px) {\n    .revistaLabel10 {\n        margin: 0 2% 0 6%;\n    }\n\n    #revista10 {\n        border-style: hidden hidden solid hidden;\n        border-radius: 0%;\n        width: 98%;\n        margin: 0 0 0 6%;\n    }\n\n}\n\n/* ---------------------------------------------------\n    BUTTON LIMPAR\n----------------------------------------------------- */\n\ndiv .buttonLimpar {\n    position: relative;\n    margin: 0% 0% 0% 15%;\n    width: 100%;\n    position: relative;\n}\n\ndiv .buttonLimpar {\n    padding-top: 1%;\n    background: white;\n    border-radius: 0%;\n    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12), 0 3px 1px -2px rgba(0, 0, 0, 0.2);\n    border: none;\n    color: #007bff;\n}\n\n\ndiv .buttonLimpar:hover {\n    background: #007bff;\n    color: white;\n}\n\ndiv .buttonLimpar:focus {\n    background: #007bff;\n    color: white;\n}\n\n\n@media only screen and (max-width: 768px) {\n    div .buttonLimpar {\n        padding: 0% 0% 0% 0%;\n        width: 100%;\n        position: relative;\n        margin: 0% 0% 0% 5%;\n    }\n\n    div .buttonLimpar {\n        padding-top: 1%;\n        background: white;\n        border-radius: 0%;\n        box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12), 0 3px 1px -2px rgba(0, 0, 0, 0.2);\n        border: none;\n        color: #007bff;\n    }\n}\n\n/* ---------------------------------------------------\n    BUTTON FILTRAR\n----------------------------------------------------- */\n\ndiv .buttonFiltrar {\n    padding: 0% 0% 2, 5% 0%;\n    position: relative;\n    margin: 0% 0% 0% 15%;\n    width: 100%;\n}\n\n\ndiv .buttonFiltrar {\n    padding-top: 1%;\n    background: #007bff;\n    border-radius: 0%;\n    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12), 0 3px 1px -2px rgba(0, 0, 0, 0.2);\n    border: none;\n}\n\ndiv .buttonFiltrar:hover {\n    background: white;\n    color: #007bff;\n}\n\n\ndiv .buttonFiltrar:focus {\n    background: white;\n    color: #007bff;\n}\n\n\n\n@media only screen and (max-width: 768px) {\n    div .buttonFiltrar {\n        padding: 2% 0;\n        width: 102%;\n        position: relative;\n        margin: 0% 0% 0% 5%;\n    }\n\n    div .buttonFiltrar {\n        padding-top: 1%;\n        background: #007bff;\n        border-radius: 0%;\n        box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12), 0 3px 1px -2px rgba(0, 0, 0, 0.2);\n        border: none;\n    }\n}\n\n/* ---------------------------------------------------\n    BUTTON IMPRIMIR\n----------------------------------------------------- */\n\n.buttonImprimir {\n    padding: 0% 0% 0% 0%;\n    width: 100%;\n    margin: 0% 0% 0% 15%;\n    position: relative;\n}\n\n\n\ndiv .buttonImprimir {\n    padding-top: 1%;\n    background: #007bff;\n    border-radius: 0%;\n    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12), 0 3px 1px -2px rgba(0, 0, 0, 0.2);\n    border: none;\n    margin: 0% 0% 0% 8%;\n}\n\ndiv .buttonImprimir:hover {\n    background: white;\n    color: #007bff;\n}\n\n\ndiv .buttonImprimir:focus {\n    background: white;\n    color: #007bff;\n}\n\n\n\n@media only screen and (max-width: 768px) {\n    div .buttonImprimir {\n        background: #007bff;\n        border-radius: 0%;\n        box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12), 0 3px 1px -2px rgba(0, 0, 0, 0.2);\n        border: none;\n        padding: 2% 0;\n        margin: 0% 0% 0% 5%;\n    }\n\n    .buttonImprimir {\n        padding: 0% 0% 0% 0%;\n        width: 102%;\n        position: relative;\n    }\n}\n\n/* ---------------------------------------------------\n    BUTTON BAIXAR\n----------------------------------------------------- */\n\n#test-table-xls-button {\n    padding: 4% 0%;\n    width: 100%;\n    position: relative;\n    margin: 0% 2% 0% 15%;\n}\n\ndiv #test-table-xls-button {\n    padding-top: 1%;\n    background: #007bff;\n    color: white;\n    border-radius: 0%;\n    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12), 0 3px 1px -2px rgba(0, 0, 0, 0.2);\n    border: none;\n}\n\ndiv #test-table-xls-button:hover {\n    background: white;\n    color: #007bff;\n}\n\n\ndiv #test-table-xls-button:focus {\n    background: white;\n    color: #007bff;\n}\n\n\n\n@media only screen and (max-width: 768px) {\n    div #test-table-xls-button {\n        padding: 2% 0;\n        background: #007bff;\n        border-radius: 0%;\n        box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12), 0 3px 1px -2px rgba(0, 0, 0, 0.2);\n        border: none;\n        color: white\n    }\n\n    #test-table-xls-button {\n        padding: 0% 0% 0% 0%;\n        margin: 0% 0% 0% 5%;\n        width: 102%;\n        position: relative;\n    }\n\n}\n\n\n\n\n\n.hide {\n    display: none;\n}\n\n#formselect {\n    padding: 4px 4px 4px 4px;\n    width: 100%;\n}\n\n.enter {\n    margin: 5% 0% 0% 0%;\n}\n\n.centrocentro {\n    text-align-last: center;\n\n}\n\n\n/* ---------------------------------------------------\n    Select Tabela\n----------------------------------------------------- */\n\n\n.labelSelect {\n    font-weight: bold;\n    font-size: 22px;\n}\n\n#select {\n    border-style: hidden hidden solid hidden;\n    border-radius: 0%;\n    width: 25%;\n}\n\n@media only screen and (max-width: 768px) {\n    #select {\n        border-style: hidden hidden solid hidden;\n        border-radius: 0%;\n        width: 80%;\n    }\n}\n\n.silas {\n    background: #007bff;\n    color: white;\n}\n\n\n.alinhamento {\n    text-align: center;\n}\n\n\n\n\n\n\n\n\n\n\n\n\n/* ================================================== */\n\n\n/* Estilo para a div principal */\n.metaslojas  {\n    margin: 10px;\n    padding: 10px;\n    border-radius: 5px;\n    box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1);\n}\n\n/* Estilo para a label com o nome do vendedor */\n.metaslojas label {\n    display: block;\n    margin: 10px 0 5px;\n    font-size: 18px;\n    font-weight: bold;\n    color: #fff;\n    background-color: #1e88e5;\n    /* padding: 5px 10px; */\n    border-radius: 3px;\n    text-align: center;\n}\n\n/* Estilo para a barra de progresso */\n.metaslojas progress {\n    display: block;\n    margin-bottom: 30px;\n}\n\n/* Estilo para a label de cada item da barra de progresso */\n.metaslojas progress label {\n    font-size: 14px;\n    font-weight: bold;\n}\n\n/* Estilo para a barra de progresso de vendas */\n.metaslojas progress [value=\"100\"]::-webkit-progress-value {\n    background-color: #28a745;\n}\n\n/* Estilo para a barra de progresso de falta */\n.metaslojas progress [value=\"100\"]::-webkit-progress-value {\n    background-color: #dc3545;\n}\n\n\n\n\n/* ---------------------------------------------------\n    modal\n----------------------------------------------------- */\n\n.modal-overlay {\n    background-color: rgba(0, 0, 0, 0.5);\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n  \n  .modal-content {\n    background-color: rgb(153, 144, 144);\n    padding: 20px;\n    border-radius: 5px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n    width: 400px;\n  }\n  \n  .modal-close {\n    position: absolute;\n    top: 10px;\n    right: 10px;\n    cursor: pointer;\n  }\n  \n  .modal-close-button {\n    background-color: #f10909;\n    color: #f7f3f3;\n    border: none;\n    padding: 8px 16px;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 14px;\n    float:left;\n    font-size: large;\n    margin-left:2%;\n    margin-top: 1%;\n  }\n  \n  .modal-close-button:hover {\n    background-color: #460303;\n  }\n  \n\n    /* Estilos para o loading */\n\n    .loading-container {\n        position: fixed;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n        background-color: rgba(0, 0, 0, 0.7);\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        z-index: 9999;\n      }\n      \n      .loading {\n        border: 4px solid #f3f3f3;\n        border-top: 4px solid #3498db;\n        border-radius: 50%;\n        width: 40px;\n        height: 40px;\n        animation: spin 2s linear infinite;\n      }\n    \n      @keyframes spin {\n        0% { transform: rotate(0deg); }\n        100% { transform: rotate(360deg); }\n      }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
